module.exports = __webpack_public_path__ + "static/img/2a.15f27ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/why/2a.png
// module id = gGdl
// module chunks = 1